import { render, staticRenderFns } from "./tracciabilità_desktop.vue?vue&type=template&id=9cb8cf9e&"
import script from "./tracciabilità_desktop.vue?vue&type=script&lang=js&"
export * from "./tracciabilità_desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports